import clsx from 'clsx';

const PaywallPriceText = ({
  value,
  className,
  supClassName = 'relative -top-[0.3em] ml-px text-[16.125px]',
}: {
  value: string;
  className?: string;
  supClassName?: string;
}) => {
  const match = value.match(/^([^\d]*)(\d+)(?:[.,](\d{1,2}))?$/);

  return (
    <span className={clsx('text-[25px] font-bold', className)}>
      {match ? (
        <>
          {match[1]}
          {match[2]}
          {match[3] ? '.' : ''}
          {match[3] && (
            <sup className={supClassName}>{match[3].padEnd(2, '0')}</sup>
          )}
        </>
      ) : (
        value
      )}
    </span>
  );
};

export default PaywallPriceText;
